import axios from 'axios';
import { backend_url as backendUrl } from './config/variables';

// Generic function to make an authenticated request
const makeAuthenticatedRequest = async (endpoint, refreshToken, options = {}) => {
  const {
    method = 'get',
    data = null,
    headers = {},
    responseType = null,
    withCredentials = false   // default to true
  } = options;

  const axiosConfig = {
    method,
    url: `${backendUrl}/${endpoint}`,
    data,
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      ...headers,
      'Accept': 'application/json',
    },
    responseType,
    withCredentials           // <-- include cookies
  };

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Token might be expired, try refreshing it
      await refreshToken();

      // retry with same config (now with fresh token)
      const retryConfig = {
        ...axiosConfig,
        headers: {
          ...axiosConfig.headers,
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        }
      };
      const retryResponse = await axios(retryConfig);
      return retryResponse;
    } else {
      console.error('Request failed:', error);
      throw error;
    }
  }
};

export default makeAuthenticatedRequest;